import { z } from "zod";

// Due to JSON.stringify on BE, response is empty string
export const EmptyResponseSchema = z.string().max(0);

// Types
export type EmptyResponse = z.infer<typeof EmptyResponseSchema>;
